import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import { getConfig } from '@edx/frontend-platform';

export default function LmsHtmlFragment({
  className,
  html,
  title,
  ...rest
}) {
  let staticUrlBase = getConfig().STATIC_URL_BASE || '/static';
  if (staticUrlBase[staticUrlBase.length - 1] === '/') {
    staticUrlBase = staticUrlBase.substring(0, staticUrlBase.length - 1);
  }

  const wholePage = `
    <html>
      <head>
        <base href="${getConfig().LMS_BASE_URL}" target="_parent">
        <link rel="stylesheet" href="${staticUrlBase}/${getConfig().LEGACY_THEME_NAME ? `${getConfig().LEGACY_THEME_NAME}/` : ''}css/bootstrap/lms-main.css">
        <style>
          body a {
              color: #00688D;
          }
  
          body.inline-link a {
              text-decoration: underline;
          }
  
          body.small {
              font-size: 0.875rem;
          }
      </style>
      </head>
      <body class="${className}">${html}</body>
    </html>
  `;

  const iframe = useRef(null);
  function handleLoad() {
    iframe.current.height = iframe.current.contentWindow.document.body.scrollHeight;
  }

  return (
    <iframe
      className="w-100 border-0"
      onLoad={handleLoad}
      ref={iframe}
      referrerPolicy="origin"
      scrolling="no"
      srcDoc={wholePage}
      title={title}
      {...rest}
    />
  );
}

LmsHtmlFragment.defaultProps = {
  className: '',
};

LmsHtmlFragment.propTypes = {
  className: PropTypes.string,
  html: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};
